import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import Gallerynew from "../Headercarousel/Gallerynew";
import ContactForm from "../ContactForm/ContactForm.js";

export default function Body({ links }) {
  return (
    <div className="banner">
      <Container>
        <Row className="headeralign">
          <Col xs={11} sm={11} md={11} lg={7} xl={7} className="headercarousel">
            <Gallerynew links={links} />
          </Col>

          <Col xs={12} sm={12} md={12} lg={5} xl={5} className="Contactform">
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
